import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import { returnValue, returnBlockValue } from '@/utils/op-types/helperFunctions'

import Card from '@/components/optypes/frontend/SideScroller/blocks/Card'
import RadioSelect from '@/components/optypes/headlesss-components/Radio/RadioSelect'
import { RadioGroup } from '@headlessui/react'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

import { RiCheckFill } from 'react-icons/ri'

const MultiChoiceBlock = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <Card className="opr-multichoiceblock">
      <div className="opr-card-header">
        <h2 className="text-lg font-bold">
          {returnBlockValue('title', 'content', opBlocks[block], content)}
        </h2>

        <h3 className="text-sm">
          {returnBlockValue('desc', 'content', opBlocks[block], content)}
        </h3>
      </div>

      <div className={Classnames('mt-4 opr-card-content')}>
        <RadioSelect
          blockId={id}
          contentKey="selected"
          className={Classnames('space-y-2 md:space-y-0 md:grid gap-2', {
            'grid-cols-1':
              returnBlockValue(
                'gridlayout',
                'design',
                opBlocks[block],
                design
              ) == 'col-1',
            'grid-cols-2':
              returnBlockValue(
                'gridlayout',
                'design',
                opBlocks[block],
                design
              ) == 'col-2',
            'grid-cols-3':
              returnBlockValue(
                'gridlayout',
                'design',
                opBlocks[block],
                design
              ) == 'col-3',
            'grid-cols-4':
              returnBlockValue(
                'gridlayout',
                'design',
                opBlocks[block],
                design
              ) == 'col-4',
          })}
        >
          {returnBlockValue(
            'radio_options',
            'content',
            opBlocks[block],
            content
          ).map((opt, index) => (
            <RadioGroup.Option
              key={opt.id}
              value={opt.option}
              className={({ checked, active }) => `
                  ${active && 'outline-none '}
                  rounded py-3 px-4 shadow  border cursor-pointer hover:shadow-lg
                `}
              style={{
                backgroundColor: returnValue(
                  'theme_cardbg',
                  opDesign,
                  pageDesign
                ),
                color: returnValue('theme_cardtext', opDesign, pageDesign),
                borderColor: returnValue(
                  'theme_cardborder',
                  opDesign,
                  pageDesign
                ),
              }}
            >
              {/* ${
                    checked &&
                    'ring-2 ring-blue-600 ring-opacity-70 outline-none'
                  } */}
              {({ checked, active }) => (
                <div className="flex items-center justify-between">
                  <div className="">
                    <div className="font-bold text-lg">{opt.headline}</div>
                    <div className="text-sm">{opt.subheadline}</div>
                  </div>
                  {checked && (
                    <div
                      style={{
                        backgroundColor: returnValue(
                          'theme_multichoicecolor',
                          opDesign,
                          pageDesign
                        ),
                      }}
                      className="rounded-full p-2  text-white"
                    >
                      <RiCheckFill />
                    </div>
                  )}
                </div>
              )}
            </RadioGroup.Option>
          ))}
        </RadioSelect>
      </div>
    </Card>
  )
}

export default MultiChoiceBlock
